var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3230_1558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 5.20471C16.1929 5.20471 5 16.3976 5 30.2047C5 44.0118 16.1929 55.2047 30 55.2047C43.8071 55.2047 55 44.0118 55 30.2047C55 16.3976 43.8071 5.20471 30 5.20471ZM0 30.2047C0 13.6362 13.4315 0.204712 30 0.204712C46.5685 0.204712 60 13.6362 60 30.2047C60 46.7733 46.5685 60.2047 30 60.2047C13.4315 60.2047 0 46.7733 0 30.2047ZM30 14.3714C31.3807 14.3714 32.5 15.4907 32.5 16.8714V27.7047H43.3333C44.714 27.7047 45.8333 28.824 45.8333 30.2047C45.8333 31.5854 44.714 32.7047 43.3333 32.7047H32.5V43.538C32.5 44.9188 31.3807 46.038 30 46.038C28.6193 46.038 27.5 44.9188 27.5 43.538V32.7047H16.6667C15.286 32.7047 14.1667 31.5854 14.1667 30.2047C14.1667 28.824 15.286 27.7047 16.6667 27.7047H27.5V16.8714C27.5 15.4907 28.6193 14.3714 30 14.3714Z",
    fill: "#4B4949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3230_1558"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.204712,
    width: 60,
    height: 60,
    fill: "#4B4949"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.256f3173632e1532d6f82ec4e22fe18c.svg";
export { ForwardRef as ReactComponent };